<template>
  <div :class="iconClasses">
    <svg
      aria-hidden="true"
      focusable="false"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496.00165 496.00165"
      width="496.00165"
      height="496.00165"
    >
      <path
        d="m 280.01736,31.241823 v 16.649518 c 0,10.797331 7.281,20.1474 17.686,23.052948 77.518,21.640768 134.31,92.682851 134.31,177.119121 0,101.62901 -82.295,183.89439 -184,183.89439 -101.69,0 -184,-82.24634 -184,-183.89439 0,-84.42023 56.786,-155.470343 134.31,-177.119121 10.407,-2.905247 17.688,-12.256619 17.688,-23.055954 V 31.249842 c 0,-15.699377 -14.834,-27.137151 -30.046,-23.220325 C 78.61536,35.66479 -0.59463988,133.33188 0.01536012,249.39341 c 0.72,136.96864 111.47999988,246.80615 248.52999988,246.52552 136.72,-0.28783 247.47,-111.15047 247.47,-247.8485 0,-115.56041 -79.14,-212.649189 -186.21,-240.091026 -15.111,-3.872727 -29.789,7.687523 -29.789,23.278456 z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'spinner',
    props: {
      extraClasses: {
        type: Array,
        default: function () {
          return []
        },
      },
    },
    computed: {
      iconClasses: function () {
        return ['icon', 'icon--spinner'].concat(this.extraClasses).join(' ')
      },
    },
  }
</script>
